<template>
  <div class="training-data-management">
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/training">培训中心</router-link>
      <span class="separator">/</span>
      <span class="current">数据管理分析治理实践培训</span>
    </nav>
    
    <!-- ===== 01. Hero 区 ===== -->
    <section class="section" style="margin-top: 6px;">
      <div class="container hero-gradient" style="border-radius: 24px; padding: 60px 48px;">
        <div class="grid-2" style="align-items: center;">
          <!-- 左侧内容 -->
          <div>
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 24px;">
              <span style="background: white; color: var(--primary-blue); font-weight: 700; padding: 4px 14px; border-radius: 40px; font-size: 14px;">北京古杉数据 · 开卷有益</span>
            </div>
            <h1 style="color: white;">数据管理分析治理实践培训 <br>中高级培训课程</h1>
            <p style="color: rgba(255,255,255,0.85); font-size: 18px; max-width: 500px;">面向企业数据人才打造的战略级数据管理分析与治理实践课程, 构建企业级数据治理体系，释放数据资产核心价值</p>
            <div class="tag-group">
              <h2 class="tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">数据治理体系建设</h2>
              <h2 class="tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">组织管理制度流程机制</h2>
              <h2 class="tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">数据资产运营管理、数据专题</h2>
              <h2 class="tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">数据分析与应用</h2>
            </div>
            <div style="display: flex; gap: 20px;">
              <a href="#enroll" class="btn-primary" style="background: white; color: var(--primary-blue); border: none;">立即报名 <i class="fas fa-arrow-right"></i></a>
              <a href="#" class="btn-outline" style="border-color: white; color: white;">获取课程手册</a>
            </div>
          </div>
          <!-- 右侧抽象视觉 -->
          <div style="display: flex; justify-content: center;">
            <div style="width: 320px; height: 320px; background: rgba(255,255,255,0.08); border-radius: 50%; display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255,255,255,0.2);">
              <i class="fas fa-user-tie" style="font-size: 120px; color: rgba(255,255,255,0.5);"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 导航栏 ===== -->
    <div class="container">
      <div class="nav-bar">
        <a href="#background" class="nav-link">课程背景</a>
        <a href="#curriculum" class="nav-link">课程体系</a>
        <a href="#instructors" class="nav-link">核心导师</a>
        <a href="#faq" class="nav-link">常见问题</a>
        <a href="#enroll" class="nav-link cta">立即报名</a>
      </div>
    </div>

    <!-- ===== 02. 课程背景区 ===== -->
    <section class="section" id="background">
      <div class="container">
        <h2>课程背景</h2>
        <div class="grid-2">
          <div>
            <p style="font-size: 16px; line-height: 1.8;">在国家数字化转型战略深化的背景下，企业数据资产化进程加速，但大多数企业仍面临数据质量不高、数据管理不完善等问题。在数字经济时代，数据已成为企业核心生产要素。企业在推进数字化转型过程中， 面临数据标准不统一、数据质量参差不齐、指标口径冲突、缺乏治理组织体系等挑战。 本课程围绕企业数据治理体系构建，结合政策趋势与实战案例，帮助企业建立规范化、体系化的数据管理机制。</p>
            <p>本课程联合工信部教育考试中心，融合国际数据管理知识体系(DMBOK)、中国数据管理成熟度（DCMM）最佳实践，帮助企业数据化负责人、数据从业者构建从战略到落地的完整数据能力，打造企业级数据战斗力。</p>
            <div style="display: flex; gap: 30px; margin-top: 24px;">
              <div><i class="fas fa-database" style="color: var(--primary-blue);"></i> <strong>战略缺失</strong> 67%企业无CDO</div>
              <div><i class="fas fa-sitemap" style="color: var(--primary-blue);"></i> <strong>体系分散</strong> 数据孤岛严重</div>
            </div>
          </div>
          <div style="background: var(--light-porcelain); border-radius: 16px; padding: 30px; display: flex; align-items: center; justify-content: center;">
            <i class="fas fa-chart-pie" style="font-size: 100px; color: var(--primary-blue); opacity: 0.5;"></i>
            <span style="margin-left: 20px; font-weight: 500;">数据管理成熟度评估</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 03. 课程目标区 (四列卡片) -->
    <section class="section bg-light">
      <div class="container">
        <h2>课程目标</h2>
        <div class="grid-4">
          <div class="card">
            <div class="icon-circle-sm" style="margin-bottom: 16px;"><i class="fas fa-chess-board"></i></div>
            <h3>技能目标</h3>
            <p>构建数据治理框架<br>制定数据标准体系<br>设计主数据机制</p>
          </div>
          <div class="card">
            <div class="icon-circle-sm" style="margin-bottom: 16px;"><i class="fas fa-chart-line"></i></div>
            <h3>能力目标</h3>
            <p>统一指标口径<br>建立质量监控体系<br>构建数据资产台账。</p>
          </div>
          <div class="card">
            <div class="icon-circle-sm" style="margin-bottom: 16px;"><i class="fas fa-shield"></i></div>
            <h3>应用目标</h3>
            <p>推动治理项目落地<br>输出治理实施方案<br>搭建治理组织架构</p>
          </div>
          <div class="card">
            <div class="icon-circle-sm" style="margin-bottom: 16px;"><i class="fas fa-robot"></i></div>
            <h3>成果认证</h3>
            <p>课程并通过考试<br>获得"首席数据官（高级）职业技能证书"<br>纳入工业和信息化人才数据库。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 04. 课程受众群体区 -->
    <section class="section">
      <div class="container">
        <h2>适合人群</h2>
        <div class="grid-2">
          <div>
            <ul style="list-style: none; padding-left: 0;">
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-right: 12px;"></i>首席数据官（CDO）/CIO/CTO 及数科公司负责人</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-right: 12px;"></i>公司中高层/数据部门负责人</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-right: 12px;"></i>业务部门负责人/业务部门从事数据相关人员</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-right: 12px;"></i>风控合规负责人、审计负责人</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-right: 12px;"></i>财务数字化负责人</li>
            </ul>
          </div>
          <div style="background: var(--light-porcelain); border-radius: 16px; padding: 32px;">
            <p style="font-weight: 500;">课程定位为高阶战略层，要求学员拥有5年以上管理经验，致力于成为企业数据价值的驱动者。每期限35人，保证小班深度研讨。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 05. 权威认证与合作机构区 -->
    <section class="section bg-light">
      <div class="container">
        <h2>权威认证与联合机构</h2>
        <div class="grid-2" style="align-items: center;">
          <div style="background: white; border-radius: 24px; padding: 40px; text-align: center; box-shadow: var(--card-shadow);">
            <i class="fas fa-certificate" style="font-size: 80px; color: var(--primary-blue);"></i>
            <h3 style="margin: 20px 0 10px;">工信部电子标准院</h3>
            <p>联合项目认证 · 国标权威证书</p>
            <p style="font-size: 14px;">完成课程并通过考试，获得"首席数据官（高级）职业技能证书"，纳入工业和信息化人才数据库。</p>
          </div>
          <div>
            <p style="font-weight: 600;">证书说明：</p>
            <p>由工信部电子工业标准化研究院颁发《数据管理分析师》证书，可作为数据领域专业能力证明，助力企业数据资产评估、项目投标、个人职称晋升。证书唯一编号，官网可查。</p>
            <a href="#" class="internal-link">查看证书样本 <i class="fas fa-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </section>

    <!-- 06. 课程体系结构区 -->
    <section class="section" id="curriculum">
      <div class="container">
        <h2>课程体系 · 四大模块</h2>
        <div class="grid-4">
          <div class="card bg-porcelain" style="border: none;">
            <h3>模块一：数据战略与组织治理</h3>
            <ul style="list-style: none; padding-left: 0;">
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> CDO定位与数据文化</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据战略规划与执行</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据治理组织架构设计</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据制度与流程体系</li>
            </ul>
          </div>
          <div class="card bg-porcelain" style="border: none;">
            <h3>模块二：数据治理体系建设</h3>
            <ul style="list-style: none; padding-left: 0;">
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据标准/质量/主数据</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据架构与元数据</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据生命周期管理</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据治理成熟度评估</li>
            </ul>
          </div>
          <div class="card bg-porcelain" style="border: none;">
            <h3>模块三：数据资产与价值实现</h3>
            <ul style="list-style: none; padding-left: 0;">
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据资产盘点与确权</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据价值评估与入表</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据流通与交易实践</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据产品设计与运营</li>
            </ul>
          </div>
          <div class="card bg-porcelain" style="border: none;">
            <h3>模块四：数据安全与合规管理</h3>
            <ul style="list-style: none; padding-left: 0;">
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据分类分级与保护</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 数据出境合规实务</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> 隐私计算与合规技术</li>
              <li><i class="fas fa-caret-right" style="color: var(--primary-blue);"></i> AI伦理与监管</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 07. 课程计划与时间安排区 -->
    <section class="section">
      <div class="container">
        <h2>课程安排（3天实战研修）</h2>
        <table class="course-table">
          <thead>
            <tr><th>时间</th><th>课程主题</th><th>模块</th></tr>
          </thead>
          <tbody>
            <tr><td>Day1 09:00-17:00</td><td>数据战略顶层设计与组织变革</td><td>模块一</td></tr>
            <tr><td>Day2 09:00-17:00</td><td>数据治理落地与资产运营实战</td><td>模块二/三</td></tr>
            <tr><td>Day3 09:00-12:00</td><td>合规与AI实践专题</td><td>模块四</td></tr>
            <tr><td>Day3 14:00-16:30</td><td>结业考试与证书颁发</td><td>考核</td></tr>
          </tbody>
        </table>
        <div style="margin-top: 24px; display: flex; gap: 40px;">
          <span><i class="fas fa-calendar-alt" style="color: var(--primary-blue);"></i> 周期：3天线下集训+1个月线上辅导</span>
          <span><i class="fas fa-laptop" style="color: var(--primary-blue);"></i> 授课方式：北京/上海/深圳 混合学习</span>
        </div>
      </div>
    </section>

    <!-- 08. 师资阵容区 -->
    <section class="section" id="instructors">
      <div class="container">
        <h2>核心导师团队</h2>
        <div class="grid-4">
          <div class="card" style="text-align: center;">
            <div class="avatar-circle"><i class="fas fa-user-tie"></i></div>
            <h3>张华平</h3>
            <p style="font-size: 14px;">工信部电子标准院 特聘专家</p>
            <p style="font-size: 14px;">原中国移动数据治理负责人，主导数据资产入表试点，服务30+央企。</p>
          </div>
          <div class="card" style="text-align: center;">
            <div class="avatar-circle"><i class="fas fa-user-graduate"></i></div>
            <h3>李敏</h3>
            <p style="font-size: 14px;">某国际咨询 数据合伙人</p>
            <p style="font-size: 14px;">前德勤数据治理总监，DAMA 认证专家，著有《数据战略落地》。</p>
          </div>
          <div class="card" style="text-align: center;">
            <div class="avatar-circle"><i class="fas fa-user-astronaut"></i></div>
            <h3>陈曦</h3>
            <p style="font-size: 14px;">阿里云 数据产品专家</p>
            <p style="font-size: 14px;">数据中台建设、数据资产运营，10年大数据实战经验。</p>
          </div>
          <div class="card" style="text-align: center;">
            <div class="avatar-circle"><i class="fas fa-user-lock"></i></div>
            <h3>王瑾</h3>
            <p style="font-size: 14px;">环球律所 数据合规合伙人</p>
            <p style="font-size: 14px;">GDPR/数据出境/上市数据合规，辅导超过50家头部企业。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 09. 往期回顾与学员反馈区 -->
    <section class="section">
      <div class="container">
        <h2>往期回顾 · 学员反馈</h2>
        <div class="grid-2">
          <div>
            <div style="background: #d4e0f0; border-radius: 16px; height: 200px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
              <i class="fas fa-image" style="font-size: 70px; color: var(--primary-blue);"></i> 培训现场
            </div>
            <p><i class="fas fa-users" style="color: var(--primary-blue);"></i> 累计培训CDO/高管 1200+ 人 · 服务企业包括国家电网、中石化、华为、招商银行等</p>
            <a href="#" class="internal-link">往期报道 <i class="fas fa-arrow-right"></i></a>
          </div>
          <div style="background: white; border-radius: 16px; padding: 30px; box-shadow: var(--card-shadow);">
            <i class="fas fa-quote-left" style="color: var(--light-porcelain); font-size: 32px;"></i>
            <p style="font-style: italic;">"课程体系非常系统，从战略到资产运营，尤其是数据入表和AI结合部分，对我们集团数据部建设很有启发。"</p>
            <p style="font-weight: 600;">—— 赵总 某大型央企数据中心负责人</p>
            <hr style="margin: 20px 0; border-color: #eee;">
            <div style="display: flex; gap: 30px; align-items: center;">
              <span><strong>97%</strong> 学员推荐</span>
              <span><strong>4.8/5.0</strong> 课程满意度</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 10. FAQ模块 -->
    <section class="section" id="faq">
      <div class="container">
        <h2>常见问题</h2>
        <div style="display: grid; gap: 20px;">
          <div style="background: var(--light-porcelain); border-radius: 16px; padding: 24px;">
            <h3><i class="fas fa-question-circle" style="color: var(--primary-blue);"></i> 课程是否需要技术背景？？</h3>
            <p>无需编程基础，课程以体系建设与实战方法为主。</p>
          </div>

          <div style="background: var(--light-porcelain); border-radius: 16px; padding: 24px;">
            <h3><i class="fas fa-question-circle" style="color: var(--primary-blue);"></i> 是否支持企业定制？</h3>
            <p>支持企业内训定制，可结合行业场景设计课程。</p>
          </div>
          <div style="background: var(--light-porcelain); border-radius: 16px; padding: 24px;">
            <h3><i class="fas fa-question-circle" style="color: var(--primary-blue);"></i> 是否包含案例演练？</h3>
            <p>课程中包含丰富的案例演练，帮助学员将理论知识应用到实际场景中。课程包含真实企业数据治理案例分析与实战演练。</p>
          </div>            
          <div style="background: var(--light-porcelain); border-radius: 16px; padding: 24px;">
            <h3><i class="fas fa-question-circle" style="color: var(--primary-blue);"></i> 可以获得什么证书？</h3>
            <p>通过考试后，由工信部教育考试中心颁发《首席数据官（高级）》职业技能证书，权威可查。</p>
          </div>
        </div>
        <div style="margin-top: 24px;">
          <a href="#" class="internal-link">查看完整课程大纲 <i class="fas fa-download"></i></a>
        </div>
      </div>
    </section>

    <!-- 11 底部转化模块 -->
    <section id="contact" class="section" style="margin-bottom: 50px;">
      <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 预约咨询 </h2>  
      <!-- early-bird-container: 早鸟容器，包括左侧 early-bird-left、右侧 early-bird-right -->
       <div class="p-10 rounded-2xl border border-divider shadow-sm" style="padding-top: 4rem; padding-bottom: 4rem;">
          <!-- Section-Title -->
          <div class="early-bird-container">
              <!-- 左侧文案 -->
              <div class="early-bird-left">
                <h2 class="early-bird-title">
                  {{ courseName }}
                </h2>
                <div class="early-bird-info">
                  <p>
                    <i class="fas fa-calendar-alt"></i>
                    <span>开课时间：{{ startDate }}</span>
                  </p>
                  <p>
                    <i class="fas fa-users"></i>
                    <span>名额限制：仅剩 <span class="highlight">{{ spotsLeft }}</span> 席 / 每班{{ classSize }}人</span>
                  </p>
                  <p>
                    <i class="fas fa-gift"></i>
                    <span>早鸟优惠截止 <span class="highlight">{{ earlyBirdDeadline }}</span></span>
                  </p>
                </div>
              </div>

              <!-- 右侧双二维码 -->
              <div class="early-bird-right">
                <div
                  v-for="(advisor, index) in advisors"
                  :key="index"
                  class="advisor-card"
                >
                  <div class="advisor-qr">
                    <img :src="advisor.qrCode" alt="顾问二维码" style="width: 100%; height: auto; border-radius: 8px;">
                  </div>
                  <div class="advisor-name">{{ advisor.name }}</div>
                  <div class="advisor-title">{{ advisor.title }}</div>
                  <div class="advisor-hint">{{ advisor.hint }}</div>
                </div>
              </div>
          </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'EarlyBirdSection',
  props: {
    // 课程名称，支持自定义
    courseName: {
      type: String,
      default: '报名本期 数据管理分析与治理 实践培训课程'
    },
    startDate: {
      type: String,
      default: '2025年6月20日（北京）'
    },
    spotsLeft: {
      type: [String, Number],
      default: 10
    },
    classSize: {
      type: [String, Number],
      default: 35
    },
    earlyBirdDeadline: {
      type: String,
      default: '3月31日'
    },
    // 顾问信息数组
    advisors: {
      type: Array,
      default: () => [
        {
          name: '顾老师',
          title: '首席咨询顾问',
          hint: '扫码咨询 · 抢占名额',
          qrCode: require('@/assets/img/qr_gu.jpg')
        },
        {
          name: '桑老师',
          title: '课程规划专家',
          hint: '扫码咨询 · 获取大纲',
          qrCode: require('@/assets/img/qr_sang.jpg')
        }
      ]
    }
  }
}
</script>

<style scoped>
/* ---------- 全局重置与变量 ---------- */
.training-data-management {
  font-family: 'Inter', 'Noto Serif SC', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  max-width: width 1200px;

}

/* 主蓝 #1F3F8F / 深靛蓝 #0E1F52 / 淡瓷蓝 #EAF0FB / 墨蓝灰 #2B2F3A */
.training-data-management {
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --text-dark: #2B2F3A;
  --accent-blue: #1a73e8;
  --border-light: #e9edf4;
  --bg-light: #f5f7fa;
  --card-shadow: 0 12px 28px rgba(0, 10, 30, 0.04), 0 4px 12px rgba(0, 20, 40, 0.03);
}


/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  color: #0E1F52;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #cbd5e1;
}

.breadcrumb-nav .current {
  color: var(--cdo-text-dark);
  font-weight: 500;
}


.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 通用样式 */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}

/* 标题体系 */
h1 {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--deep-indigo);
  margin-bottom: 24px;
}

h2 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 32px;
  color: var(--deep-indigo);
  letter-spacing: -0.01em;
  position: relative;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--deep-indigo);
}

h2 {
    font-size: 28px;
    font-weight: 700;
    color: #0E1F52;
    margin-top: 20px;
    margin-bottom: 20px;
    letter-spacing: -0.01em;
    position: relative;
    display: inline-block;
}

h2:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: #1F3F8F;
    border-radius: 4px;
}

p, li {
  font-size: 16px;
  color: var(--text-dark);
  margin-bottom: 16px;
}

/* 按钮风格 */
.btn-primary {
  display: inline-block;
  background-color: var(--primary-blue);
  color: white;
  font-weight: 600;
  padding: 14px 36px;
  border-radius: 40px;
  border: 1px solid var(--primary-blue);
  transition: all 0.2s ease;
  text-decoration: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 14px rgba(31,63,143,0.2);
  cursor: pointer;
}
.btn-primary:hover {
  background-color: #0e3170;
  border-color: #0e3170;
  box-shadow: 0 12px 22px rgba(31,63,143,0.3);
}
.btn-outline {
  display: inline-block;
  background-color: transparent;
  color: var(--primary-blue);
  font-weight: 600;
  padding: 14px 36px;
  border-radius: 40px;
  border: 1px solid var(--primary-blue);
  transition: all 0.2s ease;
  text-decoration: none;
  font-size: 16px;
}
.btn-outline:hover {
  background-color: rgba(31,63,143,0.04);
  border-color: #0e3170;
  color: #0e3170;
}

/* 导航栏样式 */
.nav-bar {
  background: white;
  border-radius: 60px;
  box-shadow: 0 8px 24px rgba(31,63,143,0.08);
  padding: 12px 28px;
  margin: 30px 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  border: 1px solid rgba(31,63,143,0.1);
}
.nav-link {
  font-size: 16px;
  font-weight: 500;
  color: var(--deep-indigo);
  text-decoration: none;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: border-color 0.2s, color 0.2s;
}
.nav-link:hover {
  color: var(--primary-blue);
  border-bottom-color: var(--primary-blue);
}
.nav-link.cta {
  background-color: var(--primary-blue);
  color: white;
  padding: 10px 28px;
  border-radius: 40px;
  border-bottom: none;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}
.nav-link.cta:hover {
  background-color: #0e3170;
  color: white;
}

/* 卡片通用 */
.card {
  background: white;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: var(--card-shadow);
  transition: transform 0.2s;
  border: 1px solid rgba(31,63,143,0.05);
}
.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 30px rgba(31,63,143,0.08);
}

/* 网格系统 */
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

/* 背景色块 */
.bg-light {
  background-color: var(--bg-light);
}
.bg-porcelain {
  background-color: var(--light-porcelain);
}

/* 标签组 */
.tag-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0 28px;
}
.tag {
  background: rgba(31,63,143,0.05);
  color: var(--primary-blue);
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(31,63,143,0.2);
}

/* 内部链接样式 */
.internal-link {
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px dashed currentColor;
}
.internal-link:hover {
  border-bottom-style: solid;
}

/* 表格样式 */
.course-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--card-shadow);
}
.course-table th {
  background-color: var(--primary-blue);
  color: white;
  font-weight: 600;
  padding: 16px 20px;
  text-align: left;
}
.course-table td {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light);
}
.course-table tr:last-child td {
  border-bottom: none;
}

/* Hero特殊渐变 */
.hero-gradient {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  color: white;
  border-radius: 0 0 0 80px;
}

/* 图标圆形 */
.icon-circle-sm {
  width: 48px;
  height: 48px;
  background: var(--light-porcelain);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-blue);
  font-size: 20px;
}

/* 头像占位 */
.avatar-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #cbd5e1;
  margin: 0 auto 16px;
  background: linear-gradient(145deg, #d6e0f0, #b0c2da);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--deep-indigo);
  font-size: 40px;
  border: 3px solid white;
  box-shadow: 0 6px 16px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 16px;
}



/* 早鸟报名区域样式 - 青花瓷色系优化版 */
.early-bird-section {
  background-color: #e9edf4; /* 深靛蓝背景 */
  padding: 60px 0;
  margin: 60px 0;
  color: #ffffff;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.early-bird-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
}

/* 左侧文案区域 */
.early-bird-left {
  flex: 1 1 450px;
}

.early-bird-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 24px;
  color: #0E1F52;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 16px;
}

.early-bird-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 3px;
  background-color: #1F3F8F; /* 主蓝 */
  border-radius: 2px;
}

.early-bird-info p {
  font-size: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #0E1F52;
  font-weight: 400;
}

.early-bird-info i {
  width: 24px;
  color: #1F3F8F; /* 主蓝 */
  font-size: 20px;
}

.early-bird-info .highlight {
  font-weight: 700;
  color: #2A5CAA; /* 稍亮的蓝色，更醒目 */
  background: rgba(255, 255, 255, 0.15);
  padding: 2px 10px;
  border-radius: 30px;
  margin-left: 4px;
  display: inline-block;
}

/* 右侧二维码区域 */
.early-bird-right {
  flex: 1 1 400px;
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.advisor-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 28px 20px 20px;
  text-align: center;
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.25);
  flex: 0 1 200px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(31, 63, 143, 0.1);
}

.advisor-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 25px 40px rgba(0, 0, 0, 0.3);
}

.advisor-qr {
  width: 120px;
  height: 120px;
  background: #EAF0FB; /* 淡瓷蓝 */
  border-radius: 20px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #1F3F8F;
  transition: border-color 0.2s;
}

.advisor-card:hover .advisor-qr {
  border-color: #2A5CAA;
}

.advisor-qr i {
  font-size: 60px;
  color: #1F3F8F;
  opacity: 0.85;
}

.advisor-name {
  font-weight: 700;
  font-size: 20px;
  color: #0E1F52; /* 深靛蓝 */
  margin-bottom: 4px;
}

.advisor-title {
  font-size: 14px;
  color: #5f6a7d;
  margin-bottom: 16px;
  font-weight: 400;
}

.advisor-hint {
  font-size: 14px;
  font-weight: 600;
  color: #1F3F8F;
  border-top: 1px dashed #d0d9e8;
  padding-top: 14px;
  margin-top: 6px;
  letter-spacing: 0.3px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .early-bird-container {
    flex-direction: column;
    text-align: center;
  }

  .early-bird-title::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .early-bird-info p {
    justify-content: center;
  }

  .early-bird-right {
    gap: 20px;
  }

  .advisor-card {
    flex: 0 1 180px;
  }
}

@media (max-width: 480px) {
  .early-bird-title {
    font-size: 28px;
  }

  .early-bird-info p {
    font-size: 16px;
    flex-wrap: wrap;
  }
}


/* 响应式设计 */
@media (max-width: 768px) {
  .grid-2, .grid-3, .grid-4, .grid-5 {
    grid-template-columns: 1fr;
  }
  
  .nav-bar {
    flex-direction: column;
    gap: 16px;
  }
  
  h1 {
    font-size: 32px;
  }
  
  h2 {
    font-size: 24px;
  }
}
</style>
